<template>
  <q-page padding >
    <h2 class="text-center">Colour Management</h2>
    <h4>Add a Colour</h4>
    <q-card>
      <div class="row" v-if="loaded">
        <div class="q-pa-md">
          <div class="q-gutter-y-md column" >
            <div class="row" style="height: 40px; line-height: 40px; text-align: center; ">
              <div class="text-bold" style="width:150px">Colour Name:</div>
              <q-input outlined v-model="colourName" dense style="width:200px" />
            </div>
            <div class="row" style="height: 44px; line-height: 44px; text-align: center; ">
              <div class="text-bold" style="width:150px">SuperGroup:</div>
              <span v-if="dataFromQuery">{{supergroup}}</span>
              <q-select outlined v-model="supergroup" :options="superGroupList" @input="group=''"  dense style="width:200px" v-else/>
            </div>        
            <div class="row" style="height: 44px; line-height: 44px; text-align: center;" >
              <div class="text-bold" style="width:150px">Group:</div>
              <span v-if="dataFromQuery">{{group}}</span>
              <q-select outlined v-model="group" :options="generateGroupColourList(supergroup)" dense style="width:200px" v-else/>
            </div>
            <div class="row" style="line-height: 44px; text-align: center; ">
              <div class="text-bold" style="width:150px">Hex:</div>
              <q-input :rules="['anyColor']" outlined v-model="hex" dense style="width:200px">
                <template v-slot:append>
                  <div style="min-width: 25px; height: 25px; border:1px solid silver" :style="{'backgroundColor':hex}">              
                  </div>
                </template>
              </q-input>
            </div>
            <div>
              <q-color format-model="hex" v-model="hex" no-header style="margin-left: 150px; display:block; width:200px" class="column"/>
            </div>            
          </div>
        </div> 
        <div class="q-pa-md">
          <div class="q-gutter-y-md column">
            <div class="row" style="height: 40px; line-height: 40px; text-align: center; ">  
              <div class="text-bold" style="width:150px">Manufacturer:</div>
              <span v-if="dataFromQuery">{{manufacturer}}</span>
              <q-select outlined v-model="manufacturer" :options="generateManufacturersList()" dense style="width:200px" v-else/>
            </div>
            <div class="row" style="line-height: 44px; text-align: center;" >  
              <div class="text-bold" style="width:150px">Brands:</div>
              <span v-if="dataFromQuery">{{brandsSelected[0].brands.join(' / ')}}</span>
              <template v-else>
                <template  v-if="!manufacturer">
                  Select a Manufacturer
                </template>
                <template v-else>
                  <template v-if="manufacturersBrands[manufacturer].length == 1">
                    {{brandsSelected[0].brands.join(' / ')}}
                  </template>
                  <template v-else>
                    <div class="column">
                      <div class="row" v-for="(brandsArray,index) in manufacturersBrands[manufacturer]" :key="index">
                        <q-checkbox v-model="brandsSelected" :val="brandsArray"  :label="brandsArray.brands.join(' / ')" />
                      </div>                  
                    </div>
                  </template>
                </template>
              </template>
            </div>
            <div class="row" style="line-height: 44px; text-align: center; ">
              <div class="text-bold" style="width:150px">Materials:</div>
              <div class="column">
                <div class="row" v-for="(material,index) in materialsList" :key="index">
                  <q-checkbox v-model="materialsSelected" :val="material"  :label="material" />
                </div>
              </div>          
            </div>
            <div class="row" style="height: 44px; line-height: 44px; text-align: center; ">
              <div class="text-bold" style="width:150px">Item type:</div>
              <q-input outlined v-model="usedOn" dense />
            </div>
            <div class="row" style="height: 44px; line-height: 44px; text-align: center; ">
              <div class="text-bold" style="width:150px">Notes:</div>
              <div style="width: 500px">
                <q-input v-model="notes" outlined type="textarea" /> 
              </div>
            </div>              
          </div>   
        </div>      
      </div>
      <div class="text-center" v-if="loaded" >
        <q-btn accesskey="s" style="margin:30px" @click="addColours" color="primary" :disable="disableSaveButton">Add Colour</q-btn>
      </div>   
    </q-card>
    <br>    
  </q-page>
</template>

<script>
import gql from "graphql-tag";
import notifyMessage from '../../util/notifyMessage'
import notifyError from '../../util/adminNotifyError'

export default {
  name: 'Colours',
  data(){
    return{
      brandsSelected: [],
      colourName: "",
      currentEditing: "",
      dataFromQuery: false,
      group: "",
      hex: "",
      loaded: false,
      manufacturer: "",
      manufacturersBrands: {
        "360": [ { brandID: 4, brands: [ "360"] } ],
        Aragon: [ 
          { brandID: 0, brands: [ "Elevation" ] }, 
          { brandID: 1, brands: [ "Kingdom", "Working Class" ] }, 
          { brandID: 2, brands: [ "Kilter", "Urban Plastix", "Flathold" ] } ],
        blocSyndicate: [ { brandID: 6, brands: [ "Satellite" ] } ],
        COMPX: [ { brandID: 3, brands: [ "Flathold", "Kilter", "Cheeta", "Kingdom", "Urban Plastix", "AiX" ] } ],
        "COMPX PU": [ { brandID: 5, brands: [ "Working Class", "AiX", "Kingdom" ] } ],
        Dimension: [ { brandID: 7, brands: [ "Dimension" ] } ]
      },
      materialsList: [ "PE", "PU", "Fiberglass", "Wood" ],
      materialsSelected: [],
      notes: "",
      supergroup: "",
      superGroupList: [ "White", "Black", "Red", "Orange", "Green", "Purple", "Blue", "Yellow", "Teal", "Pink", "Grey", "Custom"],
      usedOn: []
    }
  },
  computed:{
    disableSaveButton(){
      if(!this.colourName || !this.supergroup || !this.group || !this.hex || this.materialsSelected.length == 0 || this.brandsSelected.length == 0){
        return true
      }else{
        return false
      }

    }
  },
  created(){
    this.loadQueryParams()
    this.loaded = true
  },
  methods: {
    async addColours(){
      try{
        let operationResults = []
        let input= {
          name: this.colourName,
          supergroup: this.supergroup,
          group: this.group,
          hex:this.hex,
          notes:this.notes,
          manufacturer:this.manufacturer,
          materials: this.materialsSelected
          }
        for(let selected of this.brandsSelected){
          input.brands = selected.brands;
          let r = await this.createColour_query(input)
          operationResults.push(r)
        }
        if(operationResults.length == 1){
          notifyMessage(this.$q,"Colour Created","Successfully"); 
        } else if (operationResults.length > 1 ){
          notifyMessage(this.$q,"Colours Created",`${operationResults.length} colours were created`); 
        }
      }catch(error){
        notifyError(this.$q,"Error adding colour",error)
      }
    },
    generateGroupColourList(SuperGroupColour){
      let groupList = []
      if(SuperGroupColour){
        groupList = ["Light","","Dark","Bright","Fluoro"]
        for(let i = 0; i<groupList.length; i++){
          let group = groupList[i] + " " + SuperGroupColour;
          groupList[i] = group.trim()
        }
      }
      return groupList
    },    
    generateManufacturersList(){
      let manufacturerList = [];
      if(this.currentEditing != this.manufacturer){
        this.brandsSelected = []
        if(this.manufacturersBrands[this.manufacturer].length == 1){
          this.brandsSelected = this.manufacturersBrands[this.manufacturer]
        }
      }
      this.currentEditing = this.manufacturer
      for(let manufacturer in this.manufacturersBrands){
        manufacturerList.push(manufacturer)
      }
      return manufacturerList; 
    },
    getBrandsById(id){
      for(let manbrand in this.manufacturersBrands){
        let brands = this.manufacturersBrands[manbrand]
        const found = brands.find(element => element.brandID == id);
        if(found){          
          return found
        }
      }
    },      
    loadQueryParams(){
      if(Object.keys(this.$route.query).length == 4 && this.$route.query.supergroup && this.$route.query.group && this.$route.query.manufacturer && this.$route.query.brandID){
        try{
          this.dataFromQuery = true;
          let query = this.$route.query;
          if(query?.supergroup) this.supergroup = query.supergroup
          if(query?.group) this.group = query.group
          if(query?.manufacturer) this.manufacturer = query.manufacturer
          if(query.brandID) this.brandsSelected.push(this.getBrandsById(query.brandID))
        }
        catch(error){
          notifyError(this.$q,"Error getting parameters",error)
        }
      }
    },
    //Query FUNCTIONS
    async createColour_query(input){      
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`mutation createColour ($input: ColourInput!) {
            createColour(input: $input) {
              id
              name
              supergroup
              group
              hex
              manufacturer
              brands
              materials
              notes
            }
          }
        `,
          variables: {
            input: input
          }
        })
        return result.data.createColour;
      } catch (error) {
        console.log("createColour_query Error:", error)
        throw new Error(error);      
      }
    }    
  }
}
</script>
